import { ReferentialKey } from 'api/referential';
import { SearchFilterEnum } from 'api/actor';
import { ComponentKey } from 'enums/componentKey';
import { InputsConfig } from 'types/form/inputsConfig';
import { addressInputsConfig } from 'features/new-actor/form/inputs-config/addressInputsConfig';
import { MiaFormFieldNames } from './MiaFormFieldNames';
import { MiaFormValues } from './MiaFormValues';

import { gerantInputsConfig } from 'back-office/shared/components/gerant/gerantFields';
export const miaInputsConfig: InputsConfig<keyof MiaFormValues> = {
  ...gerantInputsConfig,
  ...addressInputsConfig,
  [MiaFormFieldNames.CompanyName]: {
    componentKey: ComponentKey.InputText,
    name: MiaFormFieldNames.CompanyName,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.MIA.LABELS.COMPANY_NAME',
    placeholder: 'ACTOR_FORM.MIA.PLACEHOLDERS.COMPANY_NAME',
  },
  [MiaFormFieldNames.Phone]: {
    componentKey: ComponentKey.InputText,
    name: MiaFormFieldNames.Phone,
    type: 'tel',
    required: false,
    label: 'ACTOR_FORM.BROKER.LABELS.PHONE',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.PHONE',
  },
  [MiaFormFieldNames.RegistrationNumber]: {
    componentKey: ComponentKey.InputText,
    name: MiaFormFieldNames.RegistrationNumber,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.REGISTRATION_NUMBER',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.REGISTRATION_NUMBER',
  },
  [MiaFormFieldNames.Capital]: {
    componentKey: ComponentKey.InputText,
    name: MiaFormFieldNames.Capital,
    type: 'number',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.CAPITAL',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.CAPITAL',
    min: 0,
  },
  [MiaFormFieldNames.RcsCity]: {
    componentKey: ComponentKey.InputText,
    name: MiaFormFieldNames.RcsCity,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.RCS_CITY',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.RCS_CITY',
  },
  [MiaFormFieldNames.RcsNumber]: {
    componentKey: ComponentKey.InputText,
    name: MiaFormFieldNames.RcsNumber,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.RCS_NUMBER',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.RCS_NUMBER',
  },
  [MiaFormFieldNames.OriasNumber]: {
    componentKey: ComponentKey.InputText,
    name: MiaFormFieldNames.OriasNumber,
    type: 'text',
    required: true, // obligatoire pour la nature MIA
    label: 'ACTOR_FORM.BROKER.LABELS.ORIAS_NUMBER',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.ORIAS_NUMBER_REQUIRED',
  },
  [MiaFormFieldNames.Rcp]: {
    componentKey: ComponentKey.InputText,
    name: MiaFormFieldNames.Rcp,
    type: 'text',
    required: false,
    label: 'ACTOR_FORM.BROKER.LABELS.RCP',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.RCP',
  },
  [MiaFormFieldNames.ComplaintEmail]: {
    componentKey: ComponentKey.InputText,
    name: MiaFormFieldNames.ComplaintEmail,
    type: 'email',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.COMPLAINT_EMAIL',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.COMPLAINT_EMAIL',
  },
  [MiaFormFieldNames.Mandants]: {
    componentKey: ComponentKey.Custom,
    name: MiaFormFieldNames.Mandants,
  },
  [MiaFormFieldNames.FirstName]: {
    componentKey: ComponentKey.InputText,
    name: MiaFormFieldNames.FirstName,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.FIRST_NAME',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.FIRST_NAME',
  },
  [MiaFormFieldNames.LastName]: {
    componentKey: ComponentKey.InputText,
    name: MiaFormFieldNames.LastName,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.LAST_NAME',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.LAST_NAME',
  },
  [MiaFormFieldNames.Email]: {
    componentKey: ComponentKey.InputText,
    name: MiaFormFieldNames.Email,
    type: 'email',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.EMAIL',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.EMAIL',
    existenceCheck: {
      enabled: true,
      type: 'email',
      searchFilter: SearchFilterEnum.Email,
      debounceMs: 500,
      errorMessage: 'Cette adresse email existe déjà',
    },
  },
  [MiaFormFieldNames.Username]: {
    componentKey: ComponentKey.InputText,
    name: MiaFormFieldNames.Username,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.USERNAME',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.USERNAME',
  },
  [MiaFormFieldNames.Password]: {
    componentKey: ComponentKey.InputText,
    name: MiaFormFieldNames.Password,
    type: 'password',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.PASSWORD',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.PASSWORD',
  },
  [MiaFormFieldNames.PlateformeIds]: {
    componentKey: ComponentKey.ReferentialTagInput,
    referentialKey: ReferentialKey.Plateforme,
    name: MiaFormFieldNames.PlateformeIds,
    label: 'ACTOR_FORM.MIA.LABELS.ORGANIZATION',
    placeholder: 'COMMON.PLACEHOLDERS.ORGANIZATIONS',
    required: true,
  },
};
